import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useState } from "preact/hooks"
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"

var sizeOrder = ["22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "xs", "s", "m", "l", "xl", "0 (xs)", "1 (s)", "2 (m)", "3 (l)", "4 (xl)", "free"]
var brandsValues = ["MOUSSY" , "MOUSSY VINTAGE"]
var riseValues =  ["low rise", "mid rise" , "high rise"]
var DetailValues = ["clean", "distressed"]

export default function Facet({ facet, index }) {
    const { selectedFiltersCount, toggleProductFilter } = useFacet(facet)
    const [active, setActive] = useState(true)
    const [expanded, setExpanded] = useState(false)

    function showMore(e){
        e.preventDefault();
        var parent = e.target.closest(".ns-sidebar-submenu");
        var hiddenFacets = parent.querySelectorAll(".ns-facet.nosto-facet-button");
        setExpanded(true);
    }

    const filterValues = (f) => {
        if (f.name === 'Brand') {
            // Brand Facet
            return f.data.map(v => {
                if (brandsValues.includes(v.value)) {
                    const obj = {...v, displayName: brandsValues[v.value]}
                    return obj
                }
            }).filter(val => val !== undefined);
        } else if (f.name === "Rise") {
            return f.data.sort((a, b) => riseValues.indexOf(a.value) - riseValues.indexOf(b.value));
            // return f.data.map(v => {
            //     if (riseValues.includes(v.value)) {
            //         const obj = {...v, displayName: riseValues[v.value]}
            //         return obj
            //     }
            // }).filter(val => val !== undefined);
        } else if (f.name === "Denim Detail") {
            return f.data.map(v => {
                if (DetailValues.includes(v.value)) {
                    const obj = {...v, displayName: DetailValues[v.value]}
                    return obj
                }
            }).filter(val => val !== undefined);
        } else if (f.name === 'Size') {
            return f.data.sort((a, b) => sizeOrder.indexOf(a.value) - sizeOrder.indexOf(b.value));
        } else {
            return f.data;
        }
    }

    const facetData = filterValues(facet);

    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`}>
            <a
                class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated ns-facet-name-outer"
                href="javascript:void(0)"
                data-nosto-element="facet"
                onClick={() => setActive(!active)}
            >
                <span class="ns-facet-name">{facet.name} </span>
                {selectedFiltersCount > 0 && (
                    <span>({selectedFiltersCount})</span>
                )}
                <Icon name="arrow" className="ns-absolute" />
            </a>
            <div class="ns-sidebar-submenu ns-d-none ns-facet-outer">
                <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                    {facetData?.map((value, index) => (
                        <li
                            class={`${index > 9 && !expanded ? 'nosto-facet-button' : ''} ns-d-flex ns-justify-content-between ns-align-items-center ns-facet`}
                            data-nosto-element="facet-setting"
                        >
                            <Checkbox
                                value={value.displayName ? value.displayName.toString().toLowerCase() : value.value.toString().toLowerCase()}
                                selected={value.selected}
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                        </li>
                    ))}
                </ul>
                {!expanded && facet?.data?.length > 10 &&
                <div class="collection__sidebar__actions ns-view-more">
                    <a href="#" onClick={(e) => showMore(e)} data-show-more="" class="collection__sidebar__link"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-separate-vertical" viewBox="0 0 24 24"><path d="M15.5 9.5 12 6 8.5 9.5m7 4.5L12 17.5 8.5 14" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg><span>More options</span>
                    </a>
                </div>
                }
            </div>
        </li>
    )
}
